"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Colors = _interopRequireDefault(require("../../Basic/Colors/Colors"));

require("./Label.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @visibleName Labels
 */
function Label(_ref) {
  var fontWeight = _ref.fontWeight,
      children = _ref.children,
      color = _ref.color;
  var styles = {
    color: color,
    fontWeight: Label.fontWeights[fontWeight]
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "typography-label",
    style: styles
  }, children);
}

Label.propTypes = {
  /** Elements to be rendered as children of this component */
  children: _propTypes.default.node,

  /** The Label font font weight */
  fontWeight: _propTypes.default.oneOf(['normal', 'bold'])
};
Label.defaultProps = {
  fontWeight: 'normal',
  color: _Colors.default.vagaVesi
};
Label.fontWeights = {
  normal: 'normal',
  bold: 'bold'
};
var _default = Label;
exports.default = _default;